//
// AnimQueue.js -- very simple animation queue based on qcss jquery extension
//
// Example:
//   import Q from '../../core/js/AnimQueue';
//   Q(element)
//     .stop()
//     .q({color: red}, 250)
//     .q({color: blue})
//     .q(function(el) { el.innerHTML = 'Done'});
//

import is_func from './helpers/is-func';


// Queue cache
// -------------------------------------------------

export default function queue_for(el) {
  if (el.animQueue === undefined) {
    el.animQueue = Queue(el);
  }
  return el.animQueue;
}


// Queue
// -------------------------------------------------

function Queue(element) {
  var Q = [ ];
  var running = false;
  var timeout = null;


  // This is the interface to an initialized Queue
  var exp = {
    element : element,
    q : q,
    wait : wait,
    stop : stop,
    finish_all : finish_all,   // stop, but call queued functions synchronously first
  };

  return exp;

  function q(func, delay) {
    Q.push([ func, typeof delay === 'undefined' ? null : delay ]);
    if (!running) {
      next();
    }
    return exp;
  }

  function wait(delay) {
    q(function() { }, delay);
  }

  function stop() {
    Q = [ ];
    clearTimeout(timeout);
    running = false;
    return exp;
  }

  function finish_all() {
    Q.forEach(apply);
    stop();
    return exp;
  }

  function next() {
    running = Q.length > 0;
    if (Q.length === 0) {
      return;
    }
    var item = Q.shift();
    apply(item[0]);

    timeout = setTimeout(next, item[1] || 0);
  }

  function apply(x) {
    if (is_func(x)) {
      x(element);
    }
    else {
      for (var i in x) if (x.hasOwnProperty(i)) {
        element.style[i] = x[i];
      }
    }
  }
}
